import _toLower from 'lodash/toLower';
import queryString from 'query-string';
import { BASE_HOST } from './env';

export const LINKS = {
  WATCHER_LINKS: {
    pool: (pool: string, account: string, id: string, locale: string) => {
      const localePath = locale !== 'en' ? `${locale}/` : '';
      return `${BASE_HOST}/${localePath}${pool}/dashboard?account=${account}&token=${id}`
    },
  },
};

// Helper function to get settings link with pool parameter
export const getSettingsLink = (
  pool: string, 
  tab?: 'payout' | 'watchers',
  params?: Record<string, string | boolean | null | undefined>
): string => {
  const poolLower = _toLower(pool);
  const basePath = `/${poolLower}/dashboard/settings`;
  const path = tab === 'watchers' ? `${basePath}/watchers` : basePath;
  
  if (params) {
    const query = queryString.stringify(params, { skipNull: true, skipEmptyString: true });
    return query ? `${path}?${query}` : path;
  }
  
  return path;
};
